import { XpressDisciplinaryPeriodEnum } from 'app/models';

export class XpressDisciplinaryPeriodModel {
    public static XpressDisciplinaryPeriodList: Array<any> = [
        { name: 'All', value: null },
        { name: '1 Day', value: XpressDisciplinaryPeriodEnum.OneDay },
        { name: '3 Days', value: XpressDisciplinaryPeriodEnum.ThreeDays },
        { name: '7 Days', value: XpressDisciplinaryPeriodEnum.SevenDays },
        { name: '30 Days', value: XpressDisciplinaryPeriodEnum.ThirtyDays }
    ];
}
